import React, { useEffect, useState, useCallback } from "react";
import { Unity, useUnityContext } from "react-unity-webgl";

function App() {
  const { unityProvider,  isLoaded, loadingProgression, sendMessage, addEventListener, removeEventListener  } = useUnityContext({
    loaderUrl: "unity/Build/BuildsWeb.loader.js",
    dataUrl: "unity/Build/BuildsWeb.data.unityweb",
    frameworkUrl: "unity/Build/BuildsWeb.framework.js.unityweb",
    codeUrl: "unity/Build/BuildsWeb.wasm.unityweb",
    streamingAssetsUrl: "unity/StreamingAssets",
    companyName: "RanSecurity",
    productName: "Phish-Out",
    productVersion: "2.2",
  });

  const BackUrlLoginAzure = process.env.REACT_APP_REDIRECCION_BACK_LOGIN_AZURE_URL;

  const aspectRatio = 16 / 9;
  const [containerHeight, setContainerHeight] = useState(window.innerHeight - 50);
  const [containerWidth, setContainerWidth] = useState(window.innerWidth * 0.93);

  const [videosPrecargados, setVideosPrecargados] = useState({});

  useEffect(() => {
    const handleResize = () => {
      const newWidth = window.innerWidth * 0.93;
      const newHeight = newWidth / aspectRatio;
 
      if (newHeight > window.innerHeight - 50) {
        setContainerWidth(window.innerHeight * aspectRatio * 0.93);
        setContainerHeight(window.innerHeight - 50);
      } else {
        setContainerWidth(newWidth);
        setContainerHeight(newHeight);
      }
    };
    window.addEventListener("resize", handleResize);
    handleResize();

    return () => window.removeEventListener("resize", handleResize);
  }, [aspectRatio]);

  const handleFullscreenToggle = () => {
    const container = document.getElementById("unity-container");

    if (!document.fullscreenElement) {
      container.requestFullscreen().catch(err => {
        console.error(`Error al intentar entrar en modo pantalla completa: ${err}`);
      });
    } else {
      document.exitFullscreen();
    }
  };

  const verificarOCargarVideo = async (url) => {
    try {
      if ('caches' in window) {
        const cacheName = "video-cache";
        const cache = await caches.open(cacheName);
        const cachedResponse = await cache.match(url);
        if (cachedResponse) return cachedResponse.url;
        const response = await fetch(url);
        if (!response.ok) throw new Error(`Error al descargar ${url}`);
        await cache.put(url, response.clone());
        return response.url;
      } else {
        return url;
      }
    } catch (error) {
      console.error(`Error en la verificación o descarga del video ${url}:`, error);
      return url;
    }
  };
  
  // Función para precargar los videos con reintentos
  const precargarVideos = async () => {
    try {
      const videoUrls = [
        "/unity/StreamingAssets/virusWeb.mp4",
        "/unity/StreamingAssets/finalizacionWeb.mp4",
      ];
  
      const videos = {};
  
      for (const url of videoUrls) {
        const videoUrl = await verificarOCargarVideo(url);
        if (videoUrl) {
          videos[url] = videoUrl;
          console.warn("Videos cargados con exito");
        } else {
          console.error(`No se pudo precargar el video ${url} después de varios intentos.`);
        }
      }
  
      setVideosPrecargados(videos);
    } catch (error) {
      console.error("Error al precargar videos:", error);
    }
  };
  
  useEffect(() => {
    if (isLoaded) {
      precargarVideos();
    }
  }, [isLoaded]);

  useEffect(() => {
    const handleFullscreenChange = () => {
      const unityCanvas = document.querySelector("#unity-container canvas");
      if (document.fullscreenElement) {
        unityCanvas.style.width = "100%";
        unityCanvas.style.height = "100%";
      } else {
        unityCanvas.style.width = `${containerWidth}px`;
        unityCanvas.style.height = `${containerHeight}px`;
      }
    };
    document.addEventListener("fullscreenchange", handleFullscreenChange);
    return () => document.removeEventListener("fullscreenchange", handleFullscreenChange);
  }, [containerWidth, containerHeight]);


  const manejarLoginAzure = useCallback(() => {
    window.location.href = BackUrlLoginAzure;
  }, []);

  const enviarDatosUnity = (datos) => {
    sendMessage("ManagerDatos", "RecibirDatosLoginAzure", datos);
  };
  
  useEffect(() => {
    addEventListener("LoginAzure", manejarLoginAzure);
    return () => {
      removeEventListener("LoginAzure", manejarLoginAzure);
    };
  }, [addEventListener, removeEventListener, manejarLoginAzure]);

  return (
    <div
      style={{
        width: "100%",
        height: "100vh",
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center", // Centrar el contenido verticalmente
        position: "relative",     // Para posicionar elementos de manera absoluta si es necesario
      }}
    >
      {!isLoaded && (
        <div
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "60%",
            maxWidth: "400px",
            height: "30px",
            backgroundColor: "#ddd",
            borderRadius: "15px",
            overflow: "hidden",
            boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.1)",
          }}
        >
          <div
            style={{
              width: `${Math.round(loadingProgression * 100)}%`,
              height: "100%",
              backgroundColor: "#4caf50",
              transition: "width 0.3s ease",
            }}
          ></div>
        </div>
      )}
  
      <div
        id="unity-container"
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flex: "1",
          width: "100%",
        }}
      >
        <Unity
          unityProvider={unityProvider}
          style={{
            width: `${containerWidth}px`,
            height: `${containerHeight}px`,
            display: "block",
            visibility: isLoaded ? "visible" : "hidden",
          }}
        />
      </div>
  
      <button onClick={handleFullscreenToggle} style={{ padding: "10px 20px", fontSize: "16px", marginBottom: "3px", cursor: "pointer" }}>
      {document.fullscreenElement ? "Salir de Pantalla Completa" : "Pantalla Completa"}
      </button>
  
      <link rel="prefetch" href="/unity/StreamingAssets/virusWeb.mp4" as="fetch" />
      <link rel="prefetch" href="/unity/StreamingAssets/finalizacionWeb.mp4" as="fetch" />
    </div>
  );
}

export default App;